import { DictionaryItem, FailureConfig } from '@ardoq/api-types/integrations';
import { isNil } from 'lodash';

export const isString = (value: any): value is string =>
  typeof value === 'string';

export const isNonEmptyStringIncludingSpaces = (value: any): value is string =>
  typeof value === 'string' && value.length > 0;

export const isNonEmptyString = (value: any): value is string =>
  typeof value === 'string' && value.trim() !== '';

export const isNumber = (value: any): value is number =>
  typeof value === 'number' && !isNaN(value);

export const isNonNegativeNumber = (value: any): value is number =>
  typeof value === 'number' && value >= 0;

export const validateDictionary = (dictionary: DictionaryItem[]): boolean => {
  const keys = dictionary.map(item => item.key);
  const hasDuplicateKeys = keys.length !== new Set(keys).size;
  return !hasDuplicateKeys && dictionary.every(item => item.key !== item.value);
};

export const computeDictionaryValidationErrors = (
  dictionary: DictionaryItem[]
): Record<number, { key: boolean; value: boolean }> => {
  const keyCounts = new Map<string, number>();
  dictionary.forEach(item =>
    keyCounts.set(item.key, (keyCounts.get(item.key) ?? 0) + 1)
  );
  return Object.fromEntries(
    dictionary.map((item, index) => [
      index,
      {
        key: (keyCounts.get(item.key) ?? 0) > 1,
        value: item.key === item.value,
      },
    ])
  );
};

export const validateFailure = (failure: FailureConfig): boolean => {
  if (
    failure.strategy === 'use_default' &&
    !isNonEmptyString(failure.default)
  ) {
    return false;
  }
  return isNonEmptyString(failure.strategy) && !isNil(failure.warn);
};
